module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/san_marco_wallpaper-e2b774d0b2d3dda8697a78c94cd49265.jpeg";